module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.c8b6e083.ttf";